import React, { FC } from 'react';
import styled from 'styled-components';
import {
    SkeletonBlock,
    SkeletonFooterBar,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack,
    SkeletonSurface,
    SkeletonTabs
} from 'src/components/widgets/skeleton';
import { useSolutionTemplateEnvironment } from 'src/shared/hooks/useSolutionTemplateEnvironment';

const PdfPreviewShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0 92px' })``;

const EditorCardSkeleton = styled(SkeletonSurface).attrs({ $padding: '20px 24px', $radius: '16px' })``;

const EditorGridSkeleton = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) 300px;
    gap: 32px;
    min-width: 0;

    @media (max-width: 980px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

const EditorOptionsSkeleton = styled(SkeletonStack)`
    @media (max-width: 980px) {
        display: none;
    }
`;

export const PdfPreviewSettingsPageSkeleton: FC = () => {
    const { followsMenu } = useSolutionTemplateEnvironment();

    return (
        <PdfPreviewShell aria-hidden='true'>
            <SkeletonPageHeader>
                <SkeletonStack $gap='8px' $flex='1'>
                    <SkeletonBlock $width='min(220px, 100%)' $height='26px' />
                    <SkeletonBlock $width='min(620px, 100%)' $height='13px' />
                    <SkeletonBlock $width='min(180px, 100%)' $height='13px' />
                </SkeletonStack>
            </SkeletonPageHeader>
            <SkeletonStack $gap='16px'>
                <SkeletonBlock $height='58px' $radius='8px' />
                {!followsMenu && <SkeletonTabs tabWidths={['185px', '170px']} />}
                <EditorCardSkeleton>
                    <EditorGridSkeleton>
                        <SkeletonStack $gap='16px'>
                            <SkeletonRow $justify='space-between'>
                                <SkeletonBlock $width='150px' $height='20px' />
                                <SkeletonRow $gap='10px'>
                                    <SkeletonBlock $width='82px' $height='34px' $radius='6px' />
                                    <SkeletonBlock $width='88px' $height='34px' $radius='6px' />
                                </SkeletonRow>
                            </SkeletonRow>
                            <SkeletonBlock $height='54px' $radius='8px' />
                            <SkeletonBlock $height='360px' $radius='6px' />
                        </SkeletonStack>
                        <EditorOptionsSkeleton $gap='16px'>
                            <SkeletonBlock $width='130px' $height='18px' />
                            <SkeletonBlock $height='38px' $radius='6px' />
                            <SkeletonBlock $height='38px' $radius='6px' />
                            <SkeletonBlock $height='38px' $radius='6px' />
                            <SkeletonBlock $height='82px' $radius='8px' />
                        </EditorOptionsSkeleton>
                    </EditorGridSkeleton>
                </EditorCardSkeleton>
            </SkeletonStack>
            <SkeletonFooterBar>
                <SkeletonBlock $width='124px' $height='36px' $radius='6px' />
                <SkeletonBlock $width='82px' $height='36px' $radius='6px' />
            </SkeletonFooterBar>
        </PdfPreviewShell>
    );
};
